import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,App,AlertController} from 'ionic-angular';
import {AppState} from '../../../app/app.global';


import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { THIRD_APP_JUMP,NEWS_SEARCH_BY_KEYWORD,SEARCH_MYALLAPPS_BY_KEYWORD,SEARCH_MYREMINDER,SEARCH_MYTODO} from '../../../providers/config/serviceurl';

import { NewsDetail } from '../../home/news/detail/detail';
import { MessagedetailPage } from '../messagedetail/messagedetail';
import { Utils} from '../../../providers/service/utils';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
/**
 * Generated class for the SearchmorePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-searchmore',
  templateUrl: 'searchmore.html',
})
export class SearchmorePage {
  infiniteSscroll:any=null;//上拉控件
  overFlag:boolean = false;//数据全部加载完成标志
  user:any={};
  isShowNews:any = false;//搜索新闻展示
  isShowService:any = false;//搜索服务展示
  isShowReminderMsg:any = false;//搜索提醒消息展示
  isShowTodoMsg:any = false;//搜索待办消息展示
  keyword:any;//搜索关键词
  flag:any;//搜索关键词
   public newsList:any = [];//新闻列表
   public serviceList:any = []; //服务列表
  public reminderMsgList:any = [];//提醒消息列表
  public myToDoMsgList:any = [];//提醒消息列表

  pageNo:number = 0;//分页页数
	news:any = [];//新闻列表
	pageSize:number = 10;
  typeId = "";//记录新闻类型
  
  resourceUrl:any;//资源url；

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    private httpService:HttpService,public global:AppState,private inAppBrowser:InAppBrowser,
    private alertCtrl: AlertController,public appCtrl: App) {
      this.user = StorageService.getObj('currentUser');
      this.flag = navParams.data.flag;
      this.keyword = navParams.data.keyword;
      this.searchMoreList(this.flag,'refresh');

      this.resourceUrl = StorageService.getObj('resourceUrl');
  }

  searchMoreList(flag:any,oType:any){
    let params = {'username':this.user.xgh,'pageNo':this.pageNo,'pageSize':this.pageSize,'loadAll':false,'keyword':this.keyword};
    if('news' == flag){
       //搜索新闻
      this.isShowNews = true;
      this.httpService.get2(NEWS_SEARCH_BY_KEYWORD,params).then(anyObj =>this.handleNewsList(anyObj));
    }else if('service' == flag){
      //搜索服务
      this.isShowService = true;
      this.httpService.get2(SEARCH_MYALLAPPS_BY_KEYWORD,params).then(anyObj =>this.handleServiceList(anyObj));
    }else if('reminderMsg' == flag){
      //提醒消息
      this.isShowReminderMsg = true;
      let remindParams = { 'username': this.user.xgh, 'pageNo':this.pageNo,'pageSize':this.pageSize,'code': '01', 'keyword':this.keyword};
      this.httpService.get2(SEARCH_MYREMINDER,remindParams).then(anyObj =>this.handleReminderMsgList(anyObj));
    }else if('myToDoMsg' == flag){
      //待办消息
      this.isShowTodoMsg = true;
      let toDoParams = { 'username': this.user.xgh, 'pageNo':this.pageNo,'pageSize':this.pageSize,'code': '02', 'keyword':this.keyword};
      this.httpService.get2(SEARCH_MYTODO,toDoParams).then(anyObj =>this.handleMyToDoMsgList(anyObj));
    }
    if(oType == "refresh"){
      this.newsList = [];
      this.serviceList = [];
      this.reminderMsgList = [];
      this.myToDoMsgList = [];
    }
  }
  handleNewsList(obj:any){
    if(obj){
      console.log(obj);
      const array = obj.items;
      for (let index = 0; index < array.length; index++) {
        // if(array[index].releaseDate !=undefined && array[index].releaseDate !=null && array[index].releaseDate !=""){
				// 	array[index].releaseDate = Utils.formateTimeGap((new Date(array[index].releaseDate)).getTime());
				// }
        this.newsList.push(array[index]);
      }
      this.disableInfiniteSscroll(array);
    }
    
  }
  handleServiceList(obj:any){
    if(obj){
      console.log(obj);
      const array = obj.items;
      for (let index = 0; index < array.length; index++) {
        this.serviceList.push(array[index]);
      }
      this.disableInfiniteSscroll(array);
    }
  }
  handleReminderMsgList(obj:any){
    if(obj){
      // console.log(JSON.parse(obj));
      // const returnData = JSON.parse(obj).items;
      // for (let index = 0; index < returnData.length; index++) {
      //   let str = returnData[index].content;
      //   let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
      //   let result ;
      //   if((result = regex.exec(str))!=null){
      //     returnData[index].content = result[1];
      //   }
      //   this.reminderMsgList.push(returnData[index]);
      // }
      // this.disableInfiniteSscroll(returnData);
      console.log(obj);
      const returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result ;
        if((result = regex.exec(str))!=null){
          returnData[index].content = result[1];
        }
        this.reminderMsgList.push(returnData[index]);
      }
      this.disableInfiniteSscroll(returnData);
    }
  }
  handleMyToDoMsgList(obj:any){
    if(obj){
      // console.log(JSON.parse(obj));
      // const returnData = JSON.parse(obj).items;
      // for (let index = 0; index < returnData.length; index++) {
      //   let str = returnData[index].content;
      //   let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
      //   let result ;
      //   if((result = regex.exec(str))!=null){
      //     returnData[index].content = result[1];
      //   }
      //   this.myToDoMsgList.push(returnData[index]);
      // }
      
      // this.disableInfiniteSscroll(returnData);
      console.log(obj);
      const returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result ;
        if((result = regex.exec(str))!=null){
          returnData[index].content = result[1];
        }
        this.myToDoMsgList.push(returnData[index]);
      }
      
      this.disableInfiniteSscroll(returnData);
    }
  }
  
  //点击具体搜索内容
  gotoServe(event:any, item:any,flag:any){
    item.flag = flag;
    if('news' == flag){
      this.appCtrl.getRootNav().push(NewsDetail,item);
    }else if('service' == flag){
    	let colorTheme = this.global.colorTheme;
	    if(item != null && item != undefined){
		  let o = item.SERVICE_APP_SUBSERVICE;
		  if(o != null && o != undefined && o !=''){
		     let title = o[0].SUBSERVICE_NAME;
		     let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
		     let flag = "thirdApp";
		     if(url.indexOf(flag) != -1){
			   this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_self','location=yes');
		  }else{
			   this.httpService.openOuterLink(title, url,colorTheme);
		  }
		}
	  }
    }else if('reminderMsg' == flag){
      this.appCtrl.getRootNav().push(MessagedetailPage,item);
    }else if('myToDoMsg' == flag){
      this.appCtrl.getRootNav().push(MessagedetailPage,item);
    }
   
  }

  urlencode (str) {  
    str = (str + '').toString();   
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
 } 

     //上拉加载
  loadMore(refresher:any){
    if(this.infiniteSscroll == null){
      this.infiniteSscroll = refresher;
    }
  	setTimeout(() => {
      this.pageNo++;
      this.searchMoreList(this.flag,'add');
      refresher.complete();
    }, 500);

  }
  //下拉刷新
  doRefresh(refresher){
  	setTimeout(() => {
    	this.pageNo=0;
      if('news' == this.flag){
        //搜索新闻
        this.newsList = [];
     }else if('service' == this.flag){
       //搜索服务
       this.serviceList = [];
     }else if('reminderMsg' == this.flag){
       //提醒消息
       this.reminderMsgList = [];
     }else if('myToDoMsg' == this.flag){
       //待办消息
       this.myToDoMsgList = [];
     }
      this.searchMoreList(this.flag,'add');
      refresher.complete();
    }, 500);
  }

  //数据全部加载完，取消上拉功能，并显示“这是我的底线提示”
  disableInfiniteSscroll(items:any){
    if(this.infiniteSscroll != null){
      if(items == null || items == undefined || items.length == 0){
        this.overFlag = true;
        this.infiniteSscroll.enable(false);
      }else{
        this.overFlag = false;
        this.infiniteSscroll.enable(true);
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/commonsearch/searchmore/searchmore.ts